import _ from 'lodash'
import i18n, { addI18nProperty, createI18nProperty } from '@/i18n'
import { DATA_TYPE } from '@/constant/openQuestion'

export const i18nPrefix = 'admin.openQuestion'

export function parseGroup (group) {
  group._id = `g_${group.id}`
  group._vType = DATA_TYPE.GROUP
  group.cn_name = group.name
  if (group.id === -1) {
    createI18nProperty(group, 'i18n_name', `${i18nPrefix}.label.unGrouped`)
    group.cn_name = group.name = i18n.t(`${i18nPrefix}.label.unGrouped`)
  } else {
    addI18nProperty(group, 'i18n_name', 'cn_name', 'name')
  }
  group.question_templates = group.question_templates || []
  group.children = _.map(group.question_templates, (child) => parseQuestion(child, group))
  return group
}

export function parseQuestion (question, group) {
  question.group_id = group.id
  question._id = `${group._id}_q_${question.id}`
  question._vType = DATA_TYPE.QUESTION
  question._parent = group
  return question
}
